import { makeStyles, Theme, createStyles, Tab, Tabs, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectIsMobile } from "../../../../../redux/slices/cleverlynkSlice";
import { PFXCategory } from "../../../../../redux/slices/templateSlice";

interface ICategoriesTabs {
  selectedCategory: string;
  onCategoryChange: (id: string) => void;
  categories: PFXCategory[];
  color: string;
}

const CategoriesTabs = ({ selectedCategory, onCategoryChange, categories, color }: ICategoriesTabs) => {
  const isMobile = useSelector(selectIsMobile);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      rootTab: {
        minWidth: 30,
        textTransform: "none",
        marginRight: 10,
        padding: "0px 3px",
        color,
      },
      indicator: {
        backgroundColor: color,
      },
      rootTabs: {
        padding: "0px 8px",
        paddingBottom: 2,
        backgroundColor: "transparent",
        zIndex: 999,
        "& .MuiTabs-fixed.MuiTabs-scroller": {
          overflow: "auto !important",
        },
      },
    })
  );

  const classes = useStyles();

  return (
    <Tabs
      centered={!isMobile}
      key={"settings-bar-tabs"}
      value={selectedCategory}
      onChange={(e, v) => onCategoryChange(v)}
      classes={{ root: classes.rootTabs, indicator: classes.indicator }}>
      {categories.map(c => (
        <Tab
          classes={{
            root: classes.rootTab,
          }}
          value={c.id}
          label={
            <Typography variant="overline" style={{ fontSize: isMobile ? "" : "1rem" }}>
              {c.name}
            </Typography>
          }
        />
      ))}
    </Tabs>
  );
};
export default CategoriesTabs;
